import { getApiUrl } from "./branding.js";

function normalizeGatewayBaseUrl(url: string): string {
	return url
		.replace(/\/v1\/chat\/completions\/?$/, "")
		.replace(/\/v1\/responses\/?$/, "")
		.replace(/\/v1\/?$/, "")
		.replace(/\/$/, "");
}

function normalizePath(path = ""): string {
	if (!path) {
		return "";
	}

	return path.startsWith("/") ? path : `/${path}`;
}

export function getGatewayPublicBaseUrl(): string {
	const configuredGatewayUrl = process.env.GATEWAY_URL?.trim();
	if (configuredGatewayUrl) {
		return normalizeGatewayBaseUrl(configuredGatewayUrl);
	}

	return process.env.NODE_ENV === "production"
		? getApiUrl()
		: "http://localhost:4001";
}

export function getGatewayV1Url(path = ""): string {
	return `${getGatewayPublicBaseUrl()}/v1${normalizePath(path)}`;
}

export function buildGatewayVideoLogContentUrl(logId: string): string {
	return new URL(
		`/v1/videos/logs/${logId}/content`,
		`${getGatewayPublicBaseUrl()}/`,
	).toString();
}
